import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { Typography } from 'antd';
import Logger from '../../../../../lib/Logger';
import LearningAdminModuleSerieModalModules from '../containers/LearningAdminModuleSerieModalModulesContainer';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';

const { Title } = Typography;

const LearningAdminModuleSerieModalModuleSeries = ({
  action,
  partnershipId,
  load,
  value,
  defaultLimit,
  defaultOrder,
  totalRecommended,
  totalMoreContent,
  list,
  debouncedQuery,
  selectedTags,
  isVisible,
  trackerActions,
  ...props
}) => {
  useEffect(() => {
    const filter = { [action.split('_not')[0]]: value };
    let searchParams = 0;
    if (debouncedQuery.trim() !== '') {
      filter['keyword'] = debouncedQuery;
      searchParams += 1;
    }

    if (selectedTags.length > 0) {
      filter['categories'] = selectedTags.join(',');
      searchParams += 1;
    }

    if (searchParams > 0) {
      trackerActions(
        mixpanelEventsEnum.ACTIONS_PARTNER.LEARNINGS_ADMIN_PREVIEW_SEARCH
      );
    }

    filter['public_status'] = 1;

    load(partnershipId, action, filter, 1, defaultLimit, defaultOrder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnershipId, action, load, debouncedQuery, selectedTags]);

  const totalTypes = [
    {
      key: 'recommended',
      label: 'learning_module_serie_recommended',
      value: totalRecommended,
    },
    {
      key: 'recommended_not',
      label: 'learning_module_serie_recommended_not',
      value: totalMoreContent,
    },
  ];

  return (
    <Translation>
      {(t) => (
        <>
          {list.length > 0 && (
            <>
              {totalTypes
                .filter((x) => x.key === action)
                .map(
                  ({ key, label, value }) =>
                    value > 0 && (
                      <Title
                        key={key}
                        level={3}
                        className='learning-title'
                        style={{
                          marginBottom: '0',
                          marginTop: '20px',
                          marginLeft: '10px',
                        }}
                      >
                        {t(label)}
                      </Title>
                    )
                )}

              {list.map((x, index) => (
                <LearningAdminModuleSerieModalModules
                  moduleSerieId={x.id}
                  moduleSerieTitle={x.title}
                  debouncedQuery={debouncedQuery}
                  selectedTags={selectedTags}
                  isVisible={isVisible}
                  trackerActions={trackerActions}
                />
              ))}
            </>
          )}
        </>
      )}
    </Translation>
  );
};

export default LearningAdminModuleSerieModalModuleSeries;

Logger.log('silly', `LearningAdminModuleSerieModalModuleSeries loaded.`);
